import Kontakty from './Kontakty';

export default Kontakty;
